/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { Col, Layout, Menu, type MenuProps, Row, Typography } from "antd";
import {
  ClusterOutlined,
  FileOutlined,
  LogoutOutlined,
  SettingOutlined,
  UnorderedListOutlined,
  UserOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import React, { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";

import InstancesPage, { AddressInstancesPage } from "./InstancesPage";
import SingleInstancePage from "./SingleInstancePage";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import ManageUsersPage from "./UsersPage/UsersList";
import { getUserInfo, userLogout } from "../redux/slices/user/authActions";
import { selectCurrentUser } from "../redux/slices/user/userSlice";
import "../App.css";
import {
  RolesEnum,
  type UserType,
} from "../redux/slices/manageUsers/manageUsersTypes";
import { ErrorPage } from "./ErrorPage";
import ConfigurationPage from "./ConfigurationPage/ConfigurationPage";
import { SingleConfigurationPage } from "./ConfigurationPage/SingleConfigurationPage";
import IssuesPage from "./IssuesPage";
import FileSharingPage from "./FileSharingPage";
import FileSharingDownloadPage from "./FileSharingDownloadPage";
import SingleIssuePage from "./SingleIssuePage";

const { Sider } = Layout;
const { Text } = Typography;

type MenuItem = Required<MenuProps>["items"][number];

const UserInfoPanel = ({ user }: { user: UserType }): JSX.Element => {
  return (
    <div
      style={{
        fontSize: "20px",
        color: "#8c8c8c",
        position: "absolute",
        bottom: 0,
        width: "100%",
        borderTop: "1px solid #8c8c8c",
      }}
    >
      <Row style={{ margin: "10px 5px 10px 20px" }}>
        <Col span={19}>
          <Text style={{ color: "#8c8c8c" }}>{user.login}</Text>
        </Col>
        {/* <Col span={5}><LogoutOutlined /></Col> */}
      </Row>
    </div>
  );
};

const MainLayout: React.FC = () => {
  console.log("instanceId MainLayout");
  // const [currentPage, setCurrentPage] = useState("/instances");
  const location = useLocation();
  console.log("location.pathname", location.pathname);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectCurrentUser);
  const rolesCanManage: Array<RolesEnum | undefined> = [
    RolesEnum.admin,
    RolesEnum.owner,
    RolesEnum.engineer,
  ];

  const rolesCanManageUsers: Array<RolesEnum | undefined> = [
    RolesEnum.admin,
    RolesEnum.owner,
  ];

  const rolesCanManagePacketConfigurations: Array<RolesEnum | undefined> = [
    RolesEnum.admin,
    RolesEnum.owner,
    RolesEnum.engineer,
  ];

  console.log("rolesCanManage", rolesCanManage);

  useEffect(() => {
    dispatch(getUserInfo());
  }, []);

  useEffect(() => {
    // dispatch(getUserInfo());
    if (location.pathname === "/") {
      navigate("/instances");
    }
  }, [location.pathname]);

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: "group",
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } satisfies MenuItem;
  }

  const manageMenuItems: MenuItem[] = [];
  if (rolesCanManageUsers.includes(user.role)) {
    manageMenuItems.push(
      getItem("Пользователи", "/admin/users", <UserOutlined />),
    );
  }
  manageMenuItems.push(
    getItem("Обмен файлами", "/admin/file-sharing", <FileOutlined />),
  );

  if (rolesCanManagePacketConfigurations.includes(user.role))
    manageMenuItems.push(
      getItem(
        "Пакетные конфигурации",
        "/admin/configuration",
        <ClusterOutlined />,
      ),
    );

  const menuItems: MenuItem[] = [
    getItem("Устройства", "/instances", <UnorderedListOutlined />),
    getItem("Проблемы", "/issues", <WarningOutlined />),
    rolesCanManage.includes(user.role)
      ? getItem(
          "Управление",
          "/admin",
          <SettingOutlined />,
          manageMenuItems,
          "group",
        )
      : null,

    getItem(
      <>
        <div onClick={async () => await dispatch(userLogout())}>Выход</div>
      </>,

      "/logout",
      <LogoutOutlined />,
    ),
  ];

  const onMenuClick: MenuProps["onClick"] = (e) => {
    console.log("click ", e);
    navigate(e.key);
    // setCurrentPage(e.key);
  };
  return (
    <div className="app-wrapper">
      <Layout style={{ overflow: "hidden", height: "100vh" }}>
        <Sider
          className="navigation-panel"
          // breakpoint="lg"
          // collapsedWidth="0"
          // collapsible
          // onBreakpoint={(broken) => {
          //   console.log(broken);
          // }}
          // onCollapse={(collapsed, type) => {
          //   console.log(collapsed, type);
          // }}
          style={{ position: "relative" }}
        >
          <Menu
            theme="dark"
            mode="inline"
            items={menuItems}
            onClick={onMenuClick}
            selectedKeys={[location.pathname]}
          />
          <UserInfoPanel user={user} />
        </Sider>
        <Layout style={{ padding: "20px", height: "auto", overflow: "scroll" }}>
          <Routes>
            <Route path="/instances" element={<InstancesPage />} />
            <Route path="/issues" element={<IssuesPage />} />
            <Route path="/issues/:issueId" element={<SingleIssuePage />} />
            <Route
              path="/download-exchange-file/:filename"
              element={<FileSharingDownloadPage />}
            />
            <Route
              path="/instances/tt/:domain/:addressId"
              element={<AddressInstancesPage />}
            />
            <Route
              path="/instances/:instanceId"
              element={<SingleInstancePage />}
            />
            <Route path="/admin/users" element={<ManageUsersPage />} />
            <Route
              path="/admin/configuration"
              element={<ConfigurationPage />}
            />
            <Route
              path="/admin/configuration/new"
              element={<SingleConfigurationPage />}
            />
            <Route
              path="/admin/configuration/:packetConfigurationId"
              element={<SingleConfigurationPage />}
            />
            <Route path="/admin/file-sharing" element={<FileSharingPage />} />

            <Route
              path="/logout"
              action={() => {
                dispatch(userLogout());
              }}
            />
            <Route
              path="*"
              element={
                <ErrorPage status={404} description={"Страница не найдена"} />
              }
            />
          </Routes>
        </Layout>
      </Layout>
    </div>
  );
};

export default MainLayout;
